import { instance } from '../instance';
import { getApiUrl } from '@utils';

export async function verifyIdealPayment(data) {
  const { paymentId, clientSecret } = data;
  const inputData = {
    clientSecret,
  };
  const req_conf = {
    method: 'put',
    url: `${getApiUrl()}/payments/${paymentId}/verify-ideal`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: inputData,
  };
  const { data: response } = await instance(req_conf);
  return response;
}
